import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { forkJoin } from 'rxjs';
import { RoleType } from 'src/app/enum/role-type';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { ReportService } from 'src/app/services/report.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-cancellation-report',
    templateUrl: './cancellation-report.component.html',
    styleUrls: ['./cancellation-report.component.scss']
})
export class CancellationReportComponent implements OnInit {

    CancellationReportForm: FormGroup;
    toMinDate: Date;
    toMaxDate: Date;
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    orderStatusList: any = []
    filteredList1: any = []
    serviceQueue: any = []
    serviceProviderTypeList: any;
    applicationstatus: any;
    filteredList2: any[];

    constructor(
        private fb: FormBuilder,
        private reportService: ReportService,
        private lookupDataService: LookupDataServiceService
    ) {
    }


    ngOnInit(): void {
        this.init()
        this.loadServiceQueue()
        this.executeServiceQueue()
    }
    init() {
        this.CancellationReportForm = this.fb.group({
            startDate: [null, Validators.required],
            endDate: [null, Validators.required],
            serviceProviderId: [null],
            changeRequestStatus:[null]
        });
    }
    Reset() {
        this.CancellationReportForm.reset()
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.CancellationReportForm.controls["startDate"].value;
        const maxDate = new Date(this.toMinDate);
        maxDate.setMonth(maxDate.getMonth() + 6);
        this.toMaxDate = maxDate;
        const today = new Date()
        if (this.toMaxDate > today)
            this.toMaxDate = today
    }
    loadServiceQueue() {
        this.serviceQueue.push(this.lookupDataService.getServiceProvider());
        this.serviceQueue.push(this.lookupDataService.getApplicationStatusForCancellation());

    }
    executeServiceQueue() {
        forkJoin(this.serviceQueue).subscribe((serviceResponse) => {
            debugger
            this.serviceProviderTypeList = serviceResponse[0];
            this.serviceProviderTypeList = this.serviceProviderTypeList.sort((a, b) => a.value.localeCompare(b.value));
            this.filteredList1 = this.serviceProviderTypeList.slice()
            this.applicationstatus = serviceResponse[1];
            this.filteredList2 = [...this.applicationstatus];
        });
    }

    generateExcel() {
        debugger
        if (!this.CancellationReportForm.value.startDate && !this.CancellationReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
        }
        else if (!this.CancellationReportForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
        }
        else if (!this.CancellationReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
        }
        else if (this.CancellationReportForm.value.startDate > this.CancellationReportForm.value.endDate) {
            if (this.CancellationReportForm.value.endDate) {
                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',
                })
            }
        }
        else {
            var filterSearch: any = {};
            var start = moment(this.CancellationReportForm.value.startDate).format("YYYY/MM/DD");
            var end = moment(this.CancellationReportForm.value.endDate).format("YYYY/MM/DD");

            filterSearch = { startDate: start, endDate: end, serviceProviderId: this.CancellationReportForm.value.serviceProviderId,ChangeRequestStatusType: this.CancellationReportForm.value.changeRequestStatus};

            this.reportService.getCancellationReport(filterSearch).subscribe((data) => {
                if (data) {
                    const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                    const downloadLink = document.createElement('a');
                    const fileName = 'CancellationReport.xls';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
            });
        }


    }

}

